module.exports = __webpack_public_path__ + "static/img/subscribe.6586f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/subscribe.jpg
// module id = M8lL
// module chunks = 3